import React from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Company/Faqs/SectionContent/Preloader/Preloader.module.scss';

const cn = classNames.bind(styles);

const Preloader = () => {
  return (
    // <div className="preloader-wrap">
    <div className={cn('preloader-container')}>
      {/* <div className="loadingio-spinner-spin"> */}
      <div className={cn('loadingio-spinner-spin')}>
        {/* <div className="ldio"> */}
        <div className={cn('ldio')}>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { Preloader };
